import { gql } from '@apollo/client';

export const DELETE_AUDIT_SESSION = gql`
  mutation DeleteAuditSession($input: DeleteAuditSessionInput!) {
    deleteAuditSession(input: $input)
  }
`;
